export enum DrawingMode {
    MARKER = "MARKER",
    POLYGON = "POLYGON",
    CIRCLE = "CIRCLE"
}

export type MarkerOverlay = Pick<google.maps.marker.AdvancedMarkerElement, "position"> & {
    map?: google.maps.Map | null
};

export type DrawingOverlay =
    | MarkerOverlay
    | google.maps.Polygon
    | google.maps.Circle;

export interface DrawResult {
    type: DrawingMode;
    overlay: DrawingOverlay;
}
